export const holdStatuses = [
  { label: 'Released', value: 'Released' },
  { label: 'Held', value: 'Held' }
];
